import { Navigate, useLocation, useParams } from "react-router-dom";
import { AgentChatConsole } from "@/components/agents/AgentChatConsole";
import { AgentContextPanel } from "@/components/agents/AgentContextPanel";

const VALID_AGENTS = new Set(["booking", "manager", "marketing", "publicist", "email", "podcast"]);

/** Routes may be static (/agents/booking) or dynamic (/agents/:agentName).
 *  Accept an explicit prop first, then fall back to useParams, then the URL path segment. */
export default function AgentPage({ agentName: agentNameProp }: { agentName?: string }) {
  const { agentName: agentNameParam } = useParams<{ agentName: string }>();
  const { pathname } = useLocation();

  const agentName =
    agentNameProp ??
    agentNameParam ??
    pathname.split("/").filter(Boolean).at(-1);

  if (!agentName || !VALID_AGENTS.has(agentName)) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="flex h-[calc(100vh-8rem)] gap-4">
      {/* Context sidebar — hidden on small screens */}
      <aside className="hidden w-72 shrink-0 overflow-y-auto lg:block">
        <AgentContextPanel agentName={agentName} />
      </aside>

      {/* Chat console */}
      <AgentChatConsole agentName={agentName} className="flex-1 min-h-0" />
    </div>
  );
}
